"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaignAttributesPlugin = void 0;
const omitEmptyProperties_1 = require("../lib/omitEmptyProperties");
const getTransform = (prefix = 'context') => (ctx) => {
    var _a, _b, _c;
    try {
        const attributes = Object.assign(Object.assign({}, ((_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a[prefix]) === null || _b === void 0 ? void 0 : _b.campaign) !== null && _c !== void 0 ? _c : {})), getAttributes());
        ctx.updateEvent(`${prefix}.campaign`, attributes);
    }
    catch (e) { }
    return ctx;
};
exports.campaignAttributesPlugin = {
    name: 'Campaing Attributes',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    identify: getTransform('traits'),
    page: getTransform(),
    track: getTransform(),
};
function getAttributes() {
    const queryParamsString = window.location.search;
    const queryParams = new URLSearchParams(queryParamsString);
    return (0, omitEmptyProperties_1.omitEmptyProperties)({
        source: queryParams.get('utm_source'),
        medium: queryParams.get('utm_medium'),
        name: queryParams.get('utm_campaign'),
        content: queryParams.get('utm_content'),
        term: queryParams.get('utm_term'),
    });
}
//# sourceMappingURL=campaignAttributes.js.map